// extracted by mini-css-extract-plugin
export default {"title":"kYT9oTCBkypMi_k3Frns","image":"EvKmAuRlekhaP05uegpP","description":"yhDmDJzmhd1u9ICqDo8_","modal":"TKoJtys7MeXmBwUond8X"};